import { useChatContext } from '@/contexts/chat/context';
import classes from './index.module.scss';

export interface StatusBoxProps {
  className?: ClassNames;
  loading?: boolean;
  children?: ReactNode;
}

export default function StatusBox({ className, loading, children }: StatusBoxProps) {
  const { chatSocket } = useChatContext();
  return (
    <span className={cls(classes.statusBox, className)}>
      {chatSocket.loading ? 'Connecting...' : loading ? 'Loading...' : children}
    </span>
  );
}
